export default "/static/dashboard/build/app/img/v2/97532272a534a3d8d62863fc6ef77dd7.png";